module.exports = __webpack_public_path__ + "img/pieceOneImg1.35241f9.webp";